module.exports = __webpack_public_path__ + "fonts/97uahxiqZRoncBaCEI3aW4X0hVgzZQUfRDuZrPvH3D8.woff2";